module.exports = __webpack_public_path__ + "static/media/repeating.ae791ee7.gif";